var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1777 10.5C15.1777 11.2956 14.8617 12.0587 14.2991 12.6213C13.7364 13.1839 12.9734 13.5 12.1777 13.5C11.3821 13.5 10.619 13.1839 10.0564 12.6213C9.4938 12.0587 9.17773 11.2956 9.17773 10.5C9.17773 9.70435 9.4938 8.94129 10.0564 8.37868C10.619 7.81607 11.3821 7.5 12.1777 7.5C12.9734 7.5 13.7364 7.81607 14.2991 8.37868C14.8617 8.94129 15.1777 9.70435 15.1777 10.5Z",
    stroke: "#001E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6777 10.5C19.6777 17.642 12.1777 21.75 12.1777 21.75C12.1777 21.75 4.67773 17.642 4.67773 10.5C4.67773 8.51088 5.46791 6.60322 6.87443 5.1967C8.28096 3.79018 10.1886 3 12.1777 3C14.1669 3 16.0745 3.79018 17.481 5.1967C18.8876 6.60322 19.6777 8.51088 19.6777 10.5Z",
    stroke: "#001E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.9cc8fa72b230248b108430f62d37a0f6.svg";
export { ForwardRef as ReactComponent };